import reportService from '@/services/report';
import goodsService from '@/services/goods';
import { mapGetters } from 'vuex';
import utils from '../../libs/utils';

export default {
  data() {
    return {
      deadline: '',
      indicationTree: [],
      labels: [],
    };
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
    ]),
  },
  methods: {
    walkTreeIndications(item) {
      const res = {
        value: item.id,
        title: item.goodsIndicationDicName,
      };
      if (item.childGoodsIndicationDicVOs.length) {
        res.children = [];
        item.childGoodsIndicationDicVOs.forEach((data) => {
          res.children.push(this.walkTreeIndications(data));
        });
      }
      return res;
    },
    getLabel() {
      goodsService.listGoodsLabels({ categoryId: 1 }).then((res) => {
        if (res.data.status === 200) {
          this.labels = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });

      // goodsService.listGoodsLabelCategories().then((res) => {
      //   if (res.data.status === 200) {
      //     const { data } = res.data;
      //     for (const key in data) {
      //       data[key].forEach((item) => {
      //         this.labels.push(item);
      //       });
      //     }
      //   } else {
      //     this.$Message.error(res.data.error);
      //   }
      // }).catch((err) => {
      //   utils.handleError(err);
      // });
    },
    fetchListIndications() {
      goodsService.listIndications().then((res) => {
        const status = res.data.status;
        const resData = [];
        if (status === 200) {
          const data = res.data.data;
          data.forEach((item) => {
            resData.push(this.walkTreeIndications(item));
          });
        }
        this.indicationTree = resData;
      });
    },
    refreshTime() {
      this.$store.commit('setDisableLoading', true);
      reportService.saleRefresh()
        .then((res) => {
          const data = res.data;
          if (data.status == 200) {
            if (data.data.success) {
              this.getRefreshTime();
              this.handleSearch(true, this.getTotal);
            } else {
              this.$Message.error(data.data.message);
            }
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getRefreshTime() {
      this.$store.commit('setDisableLoading', true);
      reportService.getSaleRefresh()
        .then((res) => {
          if (res.data.status == 200) {
            this.deadline = res.data.data.refreshTimeStr;
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
  },
};
